import React from 'react';
import type {BoxProps} from '@tempo/core';
import {Flex, Text, HStack} from '@tempo/core';
import {NavLink} from '@tempo/nextjs';

type UserMenuItemProps = {
	label: string;
	href?: string;
	icon?: React.ReactNode;
	_hover?: BoxProps['_hover'];
	children?: React.ReactNode;
} & BoxProps;

const UserMenuItem = ({
	label,
	icon,
	href,
	_hover,
	children,
	...rest
}: UserMenuItemProps) => {
	return (
		<Flex
			px="spacing.m"
			py="spacing.s"
			color="text.neutral.primary.default"
			cursor="pointer"
			_hover={{
				bg: 'background.neutral.secondary.hovered',
				color: 'text.neutral.primary.hovered',
				..._hover,
			}}
			{...rest}
			{...(href
				? {
						as: NavLink,
						href,
					}
				: {})}
		>
			<HStack flex={1} alignItems="initial">
				<Text variant="body.default.regular">{label}</Text>
				{children}
			</HStack>
			{icon}
		</Flex>
	);
};

export default UserMenuItem;
